import type { FC } from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';

export const ChartLineVectorIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 18 18">
    <path d="M2.625 13.875L7.125 9.375L10.125 12.375L16.5 5.19L15.4425 4.125L10.125 10.125L7.125 7.125L1.5 12.75L2.625 13.875Z" />
  </SvgIcon>
);
